import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { Modal } from 'antd';
import { VariantIdWithCartData, checkMustBuyWithParams } from './types';
import { GetOrderItemsWithQuantityQuery, GetCartQuery, OrderItem, Variant } from '@hooks/cart/cart.gql.generated';

export function transformVariantByOrder(data: GetCartQuery | GetOrderItemsWithQuantityQuery | undefined) {
  const orderItems: OrderItem[] = get(data, 'cart.orderItems.nodes', []);
  return orderItems.reduce((acc, orderItem) => {
    const id: string = orderItem.variant.id as string;
    if (id) {
      acc[id] = {
        orderItemId: orderItem.id,
        quantity: orderItem.quantity,
        vatWholesalePrice: Number(orderItem.vatWholesalePrice),
        materialNumber: orderItem.variant.materialNumber,
        mustBuyWithVariant: orderItem.variant.mustBuyWithVariant ? { ...orderItem.variant.mustBuyWithVariant } : null,
      };
    }
    return acc;
  }, {} as VariantIdWithCartData);
}

export function checkMustBuyWith({ variantIdWithCartData, currVariant, quantity, callback }: checkMustBuyWithParams) {
  // if (!currVariant || isEmpty(currVariant.mustBuyWithVariant) || isEmpty(variantIdWithCartData)) return;
  if (!currVariant || isEmpty(currVariant.mustBuyWithVariant)) return;

  const mustBuyWithVariant = (currVariant.mustBuyWithVariant || { id: '', materialNumber: '' }) as Variant;

  const { id: buyWithId } = mustBuyWithVariant;
  const { id: variantId } = currVariant;
  const renderWarningParams = { currVariant, quantity, callback };

  if (!variantIdWithCartData[buyWithId]) return renderWarningBuyWith(renderWarningParams);

  if (variantIdWithCartData[variantId]) {
    const { quantity: variantQuantity } = variantIdWithCartData[buyWithId];
    return quantity !== variantQuantity && renderWarningBuyWith(renderWarningParams);
  }
}

function renderWarningBuyWith({
  currVariant,
  quantity,
  callback,
}: Omit<checkMustBuyWithParams, 'variantIdWithCartData'>) {
  const { materialNumber: buyWithMaterialNumber, id } = currVariant.mustBuyWithVariant || {
    materialNumber: '',
    id: '',
  };
  const { materialNumber, id: currVariantId } = currVariant;
  const variantId = quantity === 0 ? currVariantId : id;
  if (!buyWithMaterialNumber || !id) return;
  return Modal.warning({
    title: 'Thông báo',
    content: (
      <div>
        <br />
        <div>
          Bạn cần mua {materialNumber} cùng với <span style={{ color: 'blue' }}> {buyWithMaterialNumber}</span>
        </div>
        <br />
        <div>
          Chọn &quot;Xác nhận&quot; để có {quantity} chiếc {buyWithMaterialNumber} trong Giỏ hàng
        </div>
      </div>
    ),
    width: 600,
    okText: 'Xác nhận',
    onOk: () => callback(variantId, quantity),
  });
}
